import {selectTaskManagement} from '../../selectors'
import {createSelector} from 'reselect'
import {ColumnTitlesKeys} from './constants'
import messageResource from '../../../messageResource'
import {getTaskCustomFieldsMap} from '../../common/selectors'

export const getColumnsConfiguratorMenuState = (state) => selectTaskManagement(state).columnConfiguratorMenu

export const getColumnsOrder = (state) => getColumnsConfiguratorMenuState(state).columnsOrder

export const getSelectedColumns = (state) => getColumnsConfiguratorMenuState(state).columnsSelected

export const getColumnsForConfigMenu = createSelector(
    getColumnsOrder,
    getSelectedColumns,
    getTaskCustomFieldsMap,
    (columns, shown, customFieldsMap) => {
        return columns.map(column => {
            const name = !!customFieldsMap[column] ? customFieldsMap[column].title : messageResource.getMessage(ColumnTitlesKeys[column])
            return {
                id: column,
                name: name,
                selected: !!shown[column],
            }
        })
    }
)


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/selectors.js